import { DispatchEvent } from '../types'

export const getEventName = (event: DispatchEvent): string =>
  event.type.split(':')[0]

export const getEventValue = (event: DispatchEvent): string => {
  const detail = event['detail']

  if (detail) {
    if (typeof detail === 'string') {
      return detail
    } else {
      return detail['value']
    }
  }
}
